var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordas botoes-excel"},[_c('export-excel-leitos',{attrs:{"items":_vm.listagemMapaLeitos.dados,"unidade":_vm.unidadeSelecionada}}),_c('export-excel-consolidado',{attrs:{"unidade":_vm.unidadeSelecionada}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }